import {observable, action, computed, createTransformer, reaction, extendObservable} from "mobx";
import FluxoStore from "../../comum/stores/FluxoStore";

export default class FluxoSolicitacaoStore extends FluxoStore {

    constructor(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore) {
        super(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore);
        this.dadosOk = true;
    }
    
    @computed
    get getNomeFluxo(){
        const nomeFluxo = (this.isFluxoSolicitacao) 
            ? "GloboMOTSolicitacaoMOT" 
            : this.nomeFluxo;
        return nomeFluxo
    }

    //TODO: extrair dados de FluxoStore que pertence apenas ao fluxo de solicitação de contratação
    carregarLista(tipoDetalhamento, setTitulo) {
        this.dadosOk= true;
        this.getSolicitacao(tipoDetalhamento, setTitulo);
        this.carregarLotacoes();

        this.loadingPanelStore.setIsLoading("dadosBasicosLoading", true);

        const dadosPromise = Promise.all([
            this.motivoGeralService.listMotivoAtraso().then(response => {
                this.motivosAtraso = response.data;
            }),
            this.motivoGeralService.listMotivoSubstituicaoMOTAlocada().then(response => {
                this.motivosSubstituicao = response.data;
            }),
            this.motivoGeralService.listMotivoDesistenciaAlocacaoETT().then(response => {
                this.motivosDesistenciaAlocacaoETT = response.data;
            }),
            this.ettService.list().then(response => {
                this.etts = response.data;
            }),
            this.motivoGeralService.listMotivoSubstituicaoCPF().then(response => {
                this.motivosSubstituicaoCpf = response.data;
            })
        ]);

        dadosPromise.then(() => {
            this.loadingPanelStore.setIsLoading("dadosBasicosLoading", false);
        }).catch(error => {
            this.loadingPanelStore.setIsLoading("dadosBasicosLoading", false);
            this.dadosOk= false;
            console.log(error);
        })
    }

    aprovar(id) { // tarefa aprovada
        if (id) {
            if (this.isFluxoNovo){
                var tramite = this.montarTramiteFluxo(id, "APPROVE");
                return this.fluxoService.tramitarFluxo(tramite);
            } else {
                if (this.tarefaPermiteAtualizarPayload()) {
                    this.detalhesTarefa.solicitacaoEtt = this.confirmarAlocacaoETT;
                    this.detalhesTarefa.solicitacao.matriculaAprovadoresExtra = this.apenasMatriculaAprovadoresExtraValidos;
                }
                return this.tarefaService.tramitar(id, this.nomeFluxo, this.idSolicitacao, "APPROVE", null, this.observacoes, this.detalhesTarefa, this.apenasMatriculaAprovadoresExtraValidos);
            }
        }
    }

    demandarAjustes(id) {
        if (id) {
            if (this.isFluxoNovo){
                var tramite = this.montarTramiteFluxo(id, "AJUSTE");
                return this.fluxoService.tramitarFluxo(tramite);
            } else {
                return this.tarefaService.tramitar(id, this.nomeFluxo, this.idSolicitacao, "AJUSTE", null, this.observacoes, this.detalhesTarefa)
            }
        }
    }

    rejeitar(id) {
        this.validacaoStore.desabilitarValidacao = false;
        if (id) {
            if (this.isFluxoNovo){
                var tramite = this.montarTramiteFluxo(id, "REJECT");
                return this.fluxoService.tramitarFluxo(tramite);
            } else {
                return this.tarefaService.tramitar(id, this.nomeFluxo, this.idSolicitacao, "REJECT", null, this.observacoes, this.detalhesTarefa)
            }
        }
    }
    
    getComentarios() {
        
        if (this.idSolicitacao) {
            if (this.isFluxoNovo){
                this.fluxoService.getHistoricoFLuxo(this.getNomeFluxo, this.idSolicitacao).then(response => {
                    this.comentarios = response.data;
                }).catch(error => {
                    console.log(error);
                });
            }
            else {
                super.getComentarios();
            }
        }
    }
    
    getTarefasFluxo(){
        const idFluxo = this.getIdFluxo;
        if (idFluxo){
            this.fluxoService.getEvolucaoFluxo(idFluxo).then(response => {
                //tratamento para não quebrar o detalhamento da prorrogação e término antecipado
                if(response && response.data && Array.isArray(response.data)) {
                    this.evolucaoFluxo = response.data;
                }
            }).catch(error => {
                console.log(error);
            });
        }
    }

    // monta o dto de tramite. Relativo ao TramiteFluxoDTO do backend
    montarTramiteFluxo(idTask, acao){
        var tramite = {
            idTask: idTask,
            acao: acao,
            nomeFluxo: this.nomeFluxo,
            tipoFluxo: "solicitacaoContratacao",
            tipoTarefa: this.detalhesTarefa.definicaoTarefaId,
            idSolicitacao: this.solicitacao.idSolicitacao,
            idSolicitacaoEtt: null,
            comentario: this.observacoes, 
            aprovadoresExtra: this.apenasMatriculaAprovadoresExtraValidos,
            dadosSolicitacao: this.solicitacao
        }
        return tramite
    }    
}